import {
    CLEAR_VENDOR_CHANGE_PASSWORD,
    VENDOR_CHANGE_PASSWORD_REQUEST,
    VENDOR_CHANGE_PASSWORD_SUCCESS,
} from "./type";

export const vendorChangePasswordRequest = (cred) => ({
    type: VENDOR_CHANGE_PASSWORD_REQUEST,
    payload: cred,
});

export const vendorChangePasswordSuccess = (cred) => ({
    type: VENDOR_CHANGE_PASSWORD_SUCCESS,
    payload: cred,
});

export const clearVendorChangePassword = () => ({
    type: CLEAR_VENDOR_CHANGE_PASSWORD,
});
